import React from "react";
import Container from "@mui/material/Container";
import Box from "@mui/material/Box";
import ManagerSettingsComponent from "../ManagerSettings";

function ManagerSettingsLayout() {
  return (
    <>
      <Box
        component="main"
        sx={{
          backgroundColor: (theme) =>
            theme.palette.mode === "light"
              ? theme.palette.grey[100]
              : theme.palette.grey[900],
          flexGrow: 1,
          height: "100vh",
          overflow: "auto",
        }}
      >
        <Container maxWidth="lg" sx={{ mt: 12, mb: 2 }}>
          <ManagerSettingsComponent />
        </Container>
      </Box>
    </>
  );
}

export default ManagerSettingsLayout; 